
export default {
  /**
     * @description api请求基础路径
     */
  baseUrl: {
     // pro: 'http://localhost:7745',
    //pro: 'http://192.168.1.124:8099/admin',
    pro: window.GlobalVariable.BaseUrl,
    // pro:'http://rlsb.sdzzdzkj.com/newsapi',
   
  },
  /**
     * @description 默认打开的首页的路由name值，默认为home
     */
  homeName: "home",
  // imgServer: "http://192.168.1.124:8099/img/newsimage/",
  imgServer: "http://47.93.203.158:8070/img/newsimage/",
  StudentEnCode:"curriculum"
}



// WEBPACK FOOTER //
// ./src/config/index.js